import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, mergeMap, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { KirsSummaryActions } from './kirs-summary.actions';
import { KirsSummaryService } from '../../service/kirs-summary.service';


@Injectable()
export class KirsSummaryEffects {

  loadKirsSummary$ = createEffect(
    (summaryService: KirsSummaryService = inject(KirsSummaryService)) => {
      return this.actions$.pipe(
        ofType(KirsSummaryActions.loadKirsSummary),
        switchMap(({ campaignId, attestationId, parameters }) =>
          summaryService.getKirsSummary(campaignId, attestationId, parameters).pipe(
            map((summary) =>
              KirsSummaryActions.loadKirsSummarySuccess({
                summary
              })
            ),
            catchError((error) => {
              return of(KirsSummaryActions.loadKirsSummaryFailure({ error }));
            })
          )
        )
      );
    },
    { functional: true }
  );

  loadAllKirsSummary$ = createEffect(
    (summaryService: KirsSummaryService = inject(KirsSummaryService)) => {
      return this.actions$.pipe(
        ofType(KirsSummaryActions.loadAllKirsSummary),
        switchMap(({ campaignId, attestationId, parameters }) =>
          summaryService.getKirsSummary(campaignId, attestationId, parameters).pipe(
            map((summary) =>
              KirsSummaryActions.loadAllKirsSummarySuccess({
                summary
              })
            ),
            catchError((error) => {
              return of(KirsSummaryActions.loadAllKirsSummaryFailure({ error }));
            })
          )
        )
      );
    },
    { functional: true }
  );



  exportKirsSummary$ = createEffect(
    (ks: KirsSummaryService = inject(KirsSummaryService)) => {
      return this.actions$.pipe(
        ofType(KirsSummaryActions.exportKirsSummary),
        mergeMap(({ campaignId, parameters, timeZone, attestationId }) =>
          ks.exportKirsSummary(campaignId, attestationId, timeZone, parameters).pipe(
            map((file) => {
              // Download diretto del file (se presente)
              if (file?.data && file.data.length > 0) {
                const f = file.data[0];
                const byteChars = atob(f!.content);
                const byteNumbers = new Array(byteChars.length);
                for (let i = 0; i < byteChars.length; i++) {
                  byteNumbers[i] = byteChars.charCodeAt(i);
                }
                const byteArray = new Uint8Array(byteNumbers);
                const blob = new Blob([byteArray], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
                const link = window.document.createElement("a");
                link.href = window.URL.createObjectURL(blob);
                link.download = f!.filename ?? "kirs.xlsx";
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(link.href);
              }
              return KirsSummaryActions.exportKirsSummarySuccess({
                export: file
              });
            }),
            catchError((error) => of(KirsSummaryActions.exportKirsSummaryFailure({ error })))
          )
        )
      )
    }
  );


  constructor(private actions$: Actions) { }
}
